import { loadMessages, locale } from 'devextreme/localization';
import ruMessages from 'devextreme/localization/messages/ru.json';
import vModal from 'vue-js-modal';
import vSelect from 'vue-select';
import VueHtmlToPaper from 'vue-html-to-paper';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
// import Notifications from 'vue-notification';
import Toasted from 'vue-toasted';
import { mapState } from 'vuex';
// import $ from 'jquery'
import Print from 'vue-print-nb'
// Global instruction
// import jQuery from 'jquery';
// require( 'jquery/dist/core.js');
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'vue-select/dist/vue-select.css';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
// import fingerPrint from 'fingerprintjs2';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRedo, faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  faCalendarCheck, faCalendarTimes, faCalendarPlus, faTimesCircle, faTrashAlt,
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueTippy, { TippyComponent } from 'vue-tippy';
import 'tippy.js/themes/light.css';
import store from './store';
import router from './router';
import App from './App.vue';
// import 'tippy.js/themes/light.css';
// import 'tippy.js/themes/light-border.css';
// import 'tippy.js/themes/google.css';
// import 'tippy.js/themes/translucent.css';

Vue.use(Print);
Vue.use(VueTippy);


Vue.component('tippy', TippyComponent);

// window.$ = window.jQuery = require('jquery');


library.add(faCalendarCheck, faCalendarTimes, faCalendarPlus, faTimesCircle, faTimes, faTrashAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.router = router;
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  tokenStore: ['localStorage', 'cookie'],
  // refreshData: { interval: 0.1 },
  // tokenExpired() {
  //   try {
  //     const token = jwtDecode(this.token());
  //     console.log(token.exp < (new Date()).getTime() / 1000);
  //     console.log(token.exp, (new Date()).getTime() / 1000);
  //     if (token.exp < (new Date()).getTime() / 1000) {
  //       return false;
  //       this.refresh();
  //     }
  //     console.log(token);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // },
  authRedirect: { path: '/auth/login' },
  fetchData: { url: 'auth/user', method: 'GET', enabled: false },
  logoutData: {
    url: 'auth/logout', method: 'POST', redirect: '/auth/login', makeRequest: false,
  },
});

Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 3000,
});
Vue.use(vModal, { dialog: true, dynamic: true });
Vue.component('v-select', vSelect);
Vue.use(VueHtmlToPaper, {
  specs: [
    'fullscreen=yes',
  ],
  styles: [
    'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css',
  ],
});

Vue.config.productionTip = false;
// Vue.filter('formatDate', (value) => {
//   if (value) {
//     return moment(String(value))
//       .format('MM/DD/YYYY hh:mm');
//   }
// });
new Vue({
  beforeCreate() {
    this.$auth.ready(function () {
      try {
        const userObject = jwtDecode(this.$auth.token());
        this.$auth.user(userObject);
        // if (this.$auth.check()) {
        //   this.$router.push('/');
        // }
      } catch (e) {
        console.log(e);
      }
    });
  },
  async created() {
    loadMessages(ruMessages);
    locale(navigator.language);
    await this.loadPartnerGroups();
    this.$on('PARTNER_GROUPS_CHANGED', async function () {
      await this.loadPartnerGroups();
    });
  },
  mounted() {

  },
  computed: {
    ...mapState({
      partnerGroups: state => state.PartnerGroupStore.partnerGroups,
      paymentTypes: state => state.PaymentTypeStore.paymentTypes,
    }),
  },
  methods: {
    async loadPartnerGroups() {
      await this.$store.dispatch('fetchPaymentTypes');
      await this.$store.dispatch('fetchPartnerGroups');
    },
  },
  router,
  store,
  render: h => h(App),
}).$mount('#app');
